import { render, staticRenderFns } from "./SortBtn.vue?vue&type=template&id=532e8c8b&scoped=true"
import script from "./SortBtn.vue?vue&type=script&lang=js"
export * from "./SortBtn.vue?vue&type=script&lang=js"
import style0 from "./SortBtn.vue?vue&type=style&index=0&id=532e8c8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e8c8b",
  null
  
)

export default component.exports